import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import FramedAvatar from '../../components/dash-framed-avatar/framed-avatar.jsx';

import * as styles from './author-info.css';

const ActualAuthorInfo = ({
    className,
    frameId,
    avatarSrc,
    projectTitle,
    userId,
    projectId,
    username,
    isDashProject
}) => (
    <div
        className={classNames(
            className,
            styles.authorInfo
        )}
    >
        <FramedAvatar
            avatarSrc={avatarSrc}
            avatarClassName={styles.thumbnail}
            className={styles.avatar}
            frameId={frameId}
        />
        <div className={styles.titleAuthor}>
            {isDashProject ? <h1 className={styles.projectTitle}>
                {projectTitle}
            </h1> : <a
                className={styles.link}
                href={`https://scratch.mit.edu/projects/${projectId.replace('s', '')}`}
                target="_blank"
                rel="noreferrer"
            >
                <h1 className={styles.projectTitle}>
                    {projectTitle}
                </h1>
            </a>}
            <div>
                <span className={styles.usernameLine}>
                    <FormattedMessage
                        defaultMessage="by {author}"
                        description="Displayed under project title to credit creator"
                        id="tw.studioview.authorAttribution"
                        values={{
                            author: (
                                <a
                                    className={styles.link}
                                    href={isDashProject ? `${process.env.ROOT}user#${userId}` : `https://scratch.mit.edu/users/${username}`}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <span className={styles.username}>{username}</span>
                                </a>
                            )
                        }}
                    />
                </span>
            </div>
        </div>
    </div>
);

ActualAuthorInfo.propTypes = {
    className: PropTypes.string,
    frameId: PropTypes.string,
    avatarSrc: PropTypes.string,
    projectTitle: PropTypes.string,
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    username: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    isDashProject: PropTypes.bool
};

const AuthorInfo = props => (
    props.projectId?.startsWith('s') ?
        <ActualAuthorInfo {...props} /> :
        <ActualAuthorInfo
            {...props}
            isDashProject
        />
);
AuthorInfo.propTypes = {
    projectId: PropTypes.string
};

export default AuthorInfo;
